import { IconComponent } from "@nova/component-icons"
import * as Icons from "@nova/component-icons"
import classNames from "classnames"
import { useAppDispatch, useAppSelector } from "integrations/redux/hooks"
import { PDFButtonID, selectEnabled, setActiveMenu, toggleData } from "../PDFSlice"

type PDFPanelOptionProps = {
    id: PDFButtonID
    label: string
    icon?: IconComponent
    hasMenu?: boolean
    excludedVisibilityToggle?: boolean
    showIconOnButton?: boolean
    onToggle?: () => void
}

export const PDFPanelOption = ({
    id,
    label,
    icon,
    hasMenu,
    excludedVisibilityToggle,
    showIconOnButton,
    onToggle,
}: PDFPanelOptionProps) => {
    const dispatch = useAppDispatch()
    const enabled = useAppSelector(selectEnabled())
    const isVisible = excludedVisibilityToggle ? true : enabled[id]

    return (
        <div
            className={classNames(
                "group flex justify-between py-3 gap-1 border-b border-b-gray-700 cursor-pointer"
            )}
            onClick={() => {
                dispatch(setActiveMenu(id))
                if (!hasMenu) {
                    dispatch(toggleData(id))
                } else if (!isVisible) {
                    dispatch(toggleData(id))
                    onToggle?.()
                }
            }}
        >
            <div className="flex gap-1.5 items-center relative">
                {icon && showIconOnButton && (
                    <Icons.SmallIcon Icon={icon} className="text-gray-300" />
                )}
                <small
                    className={classNames("group-hover:text-gray-0 select-none", {
                        "text-gray-500 group-hover:text-gray-200": !isVisible,
                        "text-gray-50": isVisible,
                    })}
                >
                    {label}
                </small>
            </div>
            <div className="flex items-center gap-1 relative">
                {!excludedVisibilityToggle && (
                    <Icons.SmallIcon
                        Icon={isVisible ? Icons.VisibilityEye : Icons.VisibilityEyeOff}
                        className={classNames(
                            "hover:bg-gray-700 hover:text-gray-300 cursor-pointer rounded-md",
                            {
                                "text-gray-500 ": !isVisible,
                                "text-gray-300 invisible group-hover:visible": isVisible,
                            }
                        )}
                        onClick={(e) => {
                            dispatch(toggleData(id))
                            onToggle?.()
                            //stop propagation so changing visibility doesnt enter the menu
                            e.stopPropagation()
                        }}
                    />
                )}
                <Icons.SmallIcon
                    Icon={Icons.ChevronRight}
                    className={classNames("text-gray-500 group-hover:text-blue-500", {
                        invisible: !hasMenu,
                    })}
                />
            </div>
        </div>
    )
}
